var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMauritania(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#496E2D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 18.4844C13.3359 18.4844 11.1103 16.6121 10.5642 14.1118C10.4803 14.4961 10.4348 14.8947 10.4348 15.3043C10.4348 18.378 12.9264 20.8695 16 20.8695C19.0736 20.8695 21.5652 18.3779 21.5652 15.3043C21.5652 14.8947 21.5197 14.4961 21.4358 14.1117C20.8898 16.6121 18.6641 18.4844 16 18.4844Z",
    fill: "#FFDA44"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 11.1304L16.5182 12.7247H18.1947L16.8385 13.7101L17.3565 15.3044L16.0002 14.319L14.644 15.3044L15.1621 13.7101L13.8059 12.7247H15.4822L16.0002 11.1304Z",
    fill: "#FFDA44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMauritania);
export default __webpack_public_path__ + "static/media/mauritania.d2d352a3.svg";
export { ForwardRef as ReactComponent };